import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';

import { Page } from 'ui/components';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table/config';
import { FormInput } from './component/form/input';

const UserScreen = () => {
  const UserTable = useTable('user', tableConfig);
  const StateSession = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [isShow, setIsShow] = React.useState(false);

  React.useState(() => {
    UserTable.filter('warehouse_id', StateSession?.user?.warehouse_id);
  }, [UserTable])

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'User'}
        isLoading={StateLoading}
      >
        <button
          onClick={() => setIsShow(true)}
          className="btn btn-primary px-2"
        >
          <BiAddToQueue color="white" size="14" />
          <span className="d-none d-md-block ms-1">Buat User Baru</span>
        </button>{' '}
      </Page.Header>

      <Page.Navigation toolbar>
        {/* <Tutorial /> */}
        <UserTable.Tools isLoading={StateLoading} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div className={'col-md-12   m-0 p-0'}>
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={10} />
          ) : (
            <UserTable.Render />
          )}
        </div>

        <Modal
          show={isShow}
          onHide={() => setIsShow(false)}
          backdrop="static"
          centered
          size="xl"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Buat User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormInput
              onClose={() => {
                setIsShow(false);
              }}
            />
          </Modal.Body>
        </Modal>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <UserTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default UserScreen;
